/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppAiAgentConfigDataSchema = z.object({
	id: z.string(),
	organisationId: z.string(),
	campaignId: z.string(),
	version: z.number(),
	enabled: z.boolean(),
	goal: z.string().nullable(),
	criteria: z.object({ mustHave: z.array(z.string()).default([]), niceToHave: z.array(z.string()).default([]) })
		.nullable(),
	languagePolicy: z.array(z.string()).nullable(),
	handoffPolicy: z.array(z.string()).nullable(),
	disallowedTopics: z.array(z.string()).nullable(),
	maxTurns: z.number().nullable(),
	maxDailyMessages: z.number().nullable(),
	escoConfidenceThreshold: z.string().nullable(),
	escoRequiresApproval: z.boolean(),
	approvedBy: z.string().nullable(),
	approvedAt: z.iso.datetime().nullable(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
})

export type WhatsAppAiAgentConfigDataSchema = z.infer<typeof whatsAppAiAgentConfigDataSchema>
